// extracted by mini-css-extract-plugin
export default {"container":"-z1D9","header":"yoPQ7","link":"T3ZHk"};